export enum AuthMethod {
  PhoneNumber = 'PHONE_NUMBER',
  Email = 'EMAIL',
}
